const en = {
  i18nView: {
    mainIntro: 'Social as it should be, can Voice revolutionize the social network? As the first super contract on EOS, what will Voice bring to EOS? Let\'s wait and see!',
    website: 'Website',
    view: 'View >',
    aboutVoice: 'About Voice',
    whatisVoice: 'What is Voice',
    howtoVoice: 'How to Apply',
    whattosay: 'What People Say',
    voicesay: 'From the Team',
    communitysay: 'From the Community',
    whatismore: 'More Contents',
    voiceQA: 'FAQs of Voice',
    relativeReport: 'Related News'
  }
};

export default en;